import { useEffect, useState } from 'react';
import Navbar from '../components/LandingPage/Navbar';
import LandingPage from '../pages/LandingPage/LandingPage';
import styles from './index.module.css';
import Footer from '../components/LandingPage/Footer';
import StatsSection from '../components/LandingPage/Services';
import ServicesSection from '../components/LandingPage/Services';
import AboutUs from '../components/LandingPage/AboutUs';
import Founders from '../components/LandingPage/Founders';
import Clients from '../components/LandingPage/Clients/Clients';
import Reviews from '../components/LandingPage/Reviews';
import ContactUs from '../components/LandingPage/ContactUs';
import LandingVideo from '../assets/images/landingPage/landing_video.mp4';

const LandingPageLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 1024);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div id="root">
            <Navbar toggleSidebar={toggleSidebar} />
            <div className={styles.mainContent}>
                <video
                    className={styles.backgroundVideo}
                    src={LandingVideo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    aria-hidden="true"
                />
                <LandingPage />
            </div>

            <div id="about">
                <AboutUs />
            </div>

            <div id="services">
                <ServicesSection />
            </div>

            <div id="clients">
                <Clients />
            </div>

            {/* <Reviews /> */}

            <Founders />

            <div id="contact">
                <ContactUs />
            </div>

            <Footer />
        </div>
    );
};

export default LandingPageLayout;
